"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockpileColumnPropsFullScreen = exports.StockpileColumnProps = void 0;
const constants_1 = require("utils/constants");
const StockpileColumnProps = [
    {
        show: true,
        field: 'checkpoint_name',
        title: 'Pos',
        width: '200',
        filter: 'text',
        editable: false
    },
    {
        show: true,
        field: 'brand1_name',
        title: 'Coal Brand 1',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand2_name',
        title: 'Coal Brand 2',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand3_name',
        title: 'Coal Brand 3',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand4_name',
        title: 'Coal Brand 4',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand5_name',
        title: 'Coal Brand 5',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
        editable: false
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180',
        filter: 'text',
        editable: false
    },
];
exports.StockpileColumnProps = StockpileColumnProps;
const StockpileColumnPropsFullScreen = [
    {
        show: true,
        field: 'checkpoint_name',
        title: 'Pos',
        width: 'auto',
        filter: 'text',
        editable: false
    },
    {
        show: true,
        field: 'brand1_name',
        title: 'Coal Brand 1',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand2_name',
        title: 'Coal Brand 2',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand3_name',
        title: 'Coal Brand 3',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand4_name',
        title: 'Coal Brand 4',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand5_name',
        title: 'Coal Brand 5',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
        editable: false
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180',
        filter: 'text',
        editable: false
    },
];
exports.StockpileColumnPropsFullScreen = StockpileColumnPropsFullScreen;
